/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Seo_Title_Platform_BareInputs */

const en_seo_title_platform_bare = /** @type {(inputs: Seo_Title_Platform_BareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} API`)
};

const zh_hans1_seo_title_platform_bare = /** @type {(inputs: Seo_Title_Platform_BareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} API`)
};

const pt_br2_seo_title_platform_bare = /** @type {(inputs: Seo_Title_Platform_BareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API para ${i?.name}`)
};

const es_seo_title_platform_bare = /** @type {(inputs: Seo_Title_Platform_BareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API de ${i?.name}`)
};

const fr_seo_title_platform_bare = /** @type {(inputs: Seo_Title_Platform_BareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API ${i?.name}`)
};

const de_seo_title_platform_bare = /** @type {(inputs: Seo_Title_Platform_BareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}-API`)
};

const ru_seo_title_platform_bare = /** @type {(inputs: Seo_Title_Platform_BareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API ${i?.name}`)
};

const it_seo_title_platform_bare = /** @type {(inputs: Seo_Title_Platform_BareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API ${i?.name}`)
};

/**
* | output |
* | --- |
* | "{name} API" |
*
* @param {Seo_Title_Platform_BareInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_title_platform_bare = /** @type {((inputs: Seo_Title_Platform_BareInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Title_Platform_BareInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_title_platform_bare(inputs)
	if (locale === "pt-BR") return pt_br2_seo_title_platform_bare(inputs)
	if (locale === "es") return es_seo_title_platform_bare(inputs)
	if (locale === "fr") return fr_seo_title_platform_bare(inputs)
	if (locale === "de") return de_seo_title_platform_bare(inputs)
	if (locale === "ru") return ru_seo_title_platform_bare(inputs)
	if (locale === "it") return it_seo_title_platform_bare(inputs)
	return en_seo_title_platform_bare(inputs)
});